export default __webpack_public_path__ + "assets/1bf9b057a64ed701019d1836c0d329b2.svg";